var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-contact-search", {
            attrs: {
              value: _vm.contact,
              label: _vm.label,
              fancy: "",
              "group-id": _vm.groupId,
            },
            on: {
              input: function ($event) {
                return _vm.onContact($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }